export function isValidJson(jsonString) {
  try {
    const obj = JSON.parse(jsonString);
    if (obj && typeof obj === "object") {
      return true;
    }
  } catch (e) {
    console.log("invalid json", e);
  }

  return false;
}
